import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    style: { "display": "flex", "flex-direction": "column", "width": "100%", "height": "100%" },
    class: "mini-cart"
};
const _hoisted_2 = {
    class: "flex-grow-1 bg-transparent",
    style: { "flex": "1 1 auto", "overflow-y": "auto" }
};
const _hoisted_3 = { class: "list-unstyled" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    style: { "display": "flex", "flex-direction": "row", "height": "70px", "padding": "10px" },
    class: "small"
};
const _hoisted_6 = {
    key: 0,
    style: { "flex": "0 0 30px", "display": "flex", "align-items": "center", "justify-content": "center", "height": "100%" },
    class: "color__text-primary text-center"
};
const _hoisted_7 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-square",
    viewBox: "0 0 16 16"
};
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("path", { d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" }, null, -1);
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-check-square-fill",
    viewBox: "0 0 16 16"
};
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("path", { d: "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" }, null, -1);
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = { style: { "flex": "1 1 auto", "padding-left": "10px" } };
const _hoisted_14 = { style: { "display": "flex", "flex-direction": "column" } };
const _hoisted_15 = { style: { "display": "flex", "flex-direction": "row", "padding-bottom": "5px" } };
const _hoisted_16 = { style: { "flex": "1 1 auto", "font-weight": "600" } };
const _hoisted_17 = {
    style: { "flex": "0 0 110px", "font-size": ".85rem" },
    class: "text-end"
};
const _hoisted_18 = { style: { "padding-bottom": "5px" } };
const _hoisted_19 = {
    key: 0,
    class: "badge rounded-pill bg-success me-2"
};
const _hoisted_20 = {
    key: 1,
    class: "badge rounded-pill bg-success me-2"
};
const _hoisted_21 = { class: "badge bg-warning" };
const _hoisted_22 = {
    key: 2,
    class: "small ps-2 text-success fw-bold"
};
const _hoisted_23 = {
    key: 3,
    class: "small ps-2 text-muted fw-bold"
};
const _hoisted_24 = { class: "small text-muted ps-2" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-tag",
    viewBox: "0 0 16 16"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0z" }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M2 1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2a1 1 0 0 1 1-1zm0 5.586 7 7L13.586 9l-7-7H2v4.586z" })
], -1);
const _hoisted_26 = { key: 0 };
const _hoisted_27 = {
    style: { "display": "flex", "flex-direction": "row", "padding": "10px" },
    class: "small text-center justify-content-center fw-bolder"
};
const _hoisted_28 = {
    class: "p-2 bg-light container-fluid",
    style: { "flex": "0 0 40px" }
};
const _hoisted_29 = { class: "row" };
const _hoisted_30 = { class: "col-6 pe-1" };
const _hoisted_31 = { class: "col-6 ps-1" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters['carts/allCarts'], (cart) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: "border-bottom",
                        onClick: ($event) => (_ctx.onClick(cart, $event))
                    }, [
                        _createElementVNode("div", _hoisted_5, [
                            (cart.cartState !== 'A')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (cart.isActive)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
                                        : (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            _createVNode(_component_router_link, {
                                                to: '/checkout/' + cart.cartID
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(cart.cartName), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["to"])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$utils.formatNumberWithDcp(cart.totalNetAmount, 2)) + " " + _toDisplayString(cart.currency), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        (cart.cartState === 'A')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$tc('client.Commerce.Carts.ForApproval')), 1))
                                            : _createCommentVNode("", true),
                                        (cart.initiatorName)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Von: " + _toDisplayString(cart.initiatorName), 1))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Items', cart.lineCount, { lineCount: cart.lineCount })), 1),
                                        (!cart.isReadOnly)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Private')), 1))
                                            : _createCommentVNode("", true),
                                        (cart.isReadOnly)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$tc('client.Commerce.Carts.ReadOnly')), 1))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_24, [
                                            _hoisted_25,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$tc('client.Commerce.Carts.NetPrices')), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ], 8, _hoisted_4));
                }), 256)),
                (!_ctx.$store.getters['carts/allCarts'] || _ctx.$store.getters['carts/allCarts'].length === 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$tc('client.Commerce.Carts.NoCart')), 1)
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]),
        _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_router_link, { to: "/carts" }, {
                        default: _withCtx(() => [
                            _createElementVNode("button", {
                                class: "btn btn-outline-primary w-100 btn-sm",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
                            }, [
                                _createElementVNode("small", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.AllCarts')), 1)
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                        class: "btn btn-outline-primary w-100 btn-sm",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.createCart && _ctx.createCart(...args)))
                    }, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.NewCart')), 1)
                    ])
                ])
            ])
        ])
    ]));
}
